module.exports = __webpack_public_path__ + "img/Main_bg.b68abc5e.jpg";